import { Document, Page, StyleSheet, Text } from '@react-pdf/renderer';
import { IReport } from '../../../interfaces/IReport';
import { Row } from './Row';

interface PdfProps {
  reports: IReport[];
  type: string;
}

const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    padding: '50px',
  },
  title: {
    fontSize: 16,
    textAlign: 'center',
    fontWeight: 'extrabold',
    marginBottom: 16,
  },
});

export const Pdf = ({ reports, type }: PdfProps) => (
  <Document>
    <Page size="A4" style={styles.page}>
      <Text style={styles.title}>Relatório</Text>
      <Row reports={reports} type={type} />
    </Page>
  </Document>
);
